<template>
  <div class="wimut-footer">
    <div class="footer">
      <div class="left">
        <div class="top">
          <img src="../assets/logo.png" alt="">
          <div>
            <p>กู้เงินง่าย ๆ</p>
          </div>

        </div>
        <!-- <div class="title">Sorem ipsum dolor sit amet consectetur adipiscing elit
          dapibus non apte magna ad suspendisse nec pulvi.</div> -->
        <img src="../assets/SocialLinks.png" class="SocialLinks" alt="">
      </div>
      <div class="right">
        <div class="send-box">
          <div class="title">
            สมัครสมาชิก
          </div>
          <div class="input-box">
            <input class="email" type="text" placeholder="จดหมาย" />
            <div class="btn" @click="send()">สมัครสมาชิก</div>
          </div>
          <div class="subscribing">การสมัครแสดงว่าคุณยอมรับนโยบายความเป็นส่วนตัวของเรา</div>
        </div>
      </div>
    </div>
    <div class="copyright">
      © 2026 Relume. All rights reserved.
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    send() {
      alert('ความสำเร็จ!')
    },
  },
};
</script>
<style lang="less" scoped>
.wimut-footer {
  .left {
    max-width: 520px;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #00387A;
    padding: 40px 310px 27px;
    box-sizing: border-box;

    .top {
      margin-bottom: 32px;
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
        width: 40px;
        height: 40px;
      }

      p {
        font-size: 26px;
        font-family: HeadLineA, HeadLineA;
        color: #FFFFFF;
      }

      span {
        font-size: 28px;
        font-family: HeadLineA, HeadLineA;
        color: #FFFFFF;
      }
    }

    .title {
      margin-bottom: 10px;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: 600;
      color: #FFFFFF;
    }

    .SocialLinks {
      width: 216px;
      height: 32px;
    }
  }
}

.copyright {
  background: #012B5F;
  padding: 26px 0;
  font-size: 18px;
  font-family: Inter, Inter;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
}

.send-box {
  margin-top: 10px;
  position: relative;

  .title {
    margin-bottom: 16px;
    font-size: 16px;
    font-family: Roboto, Roboto;
    font-weight: 600;
    color: #FFFFFF;
  }

  .subscribing {
    margin-top: 16px;
    font-size: 12px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #fff;
  }

  .input-box {
    display: flex;
    align-items: center;

    .email {
      width: 265px;
      height: 48px;
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      color: #333;
      padding: 0 12px;
      margin-right: 16px;
    }

    input[type="text"]:focus {
      outline: none;
    }

    .btn {
      cursor: pointer;
      width: 119px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #FFFFFF;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
</style>
